exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._365H5{right:5px;top:5px;z-index:5}._365H5,.HVmFC{position:absolute}.HVmFC{right:25px;top:25px;padding:10px 16px;display:inline-block;text-align:center;border-radius:4px;width:auto;font-size:15px;line-height:18px;color:#484848;border:1px solid transparent;min-width:52px;background:#fff}.HTtpo,.HVmFC{font-weight:400}.HTtpo{color:#ff5a5f;font-size:30px;line-height:1;font-style:normal;cursor:pointer}.HVmFC .HTtpo{font-size:20px!important}._1jIWs{padding-left:10px}", ""]);

// exports
exports.locals = {
	"iconContainer": "_365H5",
	"buttonContainer": "HVmFC",
	"wishListIcon": "HTtpo",
	"buttonText": "_1jIWs"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./~/postcss-loader?{"config":"./tools/postcss.config.js"}!./src/components/WishListIcon/WishListIcon.css
// module id = 2583
// module chunks = 15